import {Component, effect, ElementRef, input, output, signal, viewChild} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {GoogleMap, MapMarker} from '@angular/google-maps';

declare var google: any;

@Component({
  selector: 'map-component',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  imports: [TranslateModule, GoogleMap, MapMarker],
})

export class MapComponent {
  addressInput = viewChild<ElementRef>('addressInput');

  initialLocation = input<string | null>(null);
  locationUpdated = output<string>();

  address = signal<string>('');
  center = signal<google.maps.LatLngLiteral>({lat: 48.7, lng: 9.76});
  zoom = signal(5);
  markerPosition = signal<google.maps.LatLngLiteral | null>(null);

  mapOptions: google.maps.MapOptions = {
    gestureHandling: 'cooperative',
    mapTypeControl: false
  };

  constructor() {
    effect(() => {
      const loc = this.initialLocation();
      if (loc) {
        const [lat, lng] = loc.split(',').map(Number);
        const pos = {lat, lng};
        this.center.set(pos);
        this.markerPosition.set(pos);
        this.zoom.set(10);
      }
    });

    effect(() => {
      const inputEl = this.addressInput()?.nativeElement;
      if (inputEl) {
        this.initSearchBox(inputEl);
      }
    });
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.updateLocation(event.latLng);
    }
  }

  private initSearchBox(inputData: HTMLInputElement) {
    const searchBox = new google.maps.places.SearchBox(inputData);

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      if (!places || places.length === 0) { return; }

      const place = places[0];
      if (!place.geometry || !place.geometry.location) { return; }

      this.updateLocation(place.geometry.location);
      this.center.set({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      });
      this.zoom.set(17);
    });
  }

  private updateLocation(latLng: google.maps.LatLng) {
    const pos = {lat: latLng.lat(), lng: latLng.lng()};
    this.markerPosition.set(pos);
    this.locationUpdated.emit(`${pos.lat},${pos.lng}`);
    this.geocode(latLng);
  }

  private geocode(latLng: google.maps.LatLng) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({location: latLng}, (results, status) => {
      if (status === 'OK' && results?.[0]) {
        this.address.set(results[0].formatted_address);
      }
    });
  }
}
